import React, { useMemo } from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { FormInputNumberProps } from './types';
import { generateSimpleRequiredOptionalPlaceholder } from '../utils';

// components
import { InputNumber } from '@ui';

const FormInputNumber: React.FC<FormInputNumberProps> = ({
  validationRules,
  placeholder: propsPlaceholder,
  renderPlaceholder,
  ...rest
}) => {
  const { t } = useTranslation('form');

  const placeholder = useMemo(() => {
    if (propsPlaceholder) {
      return propsPlaceholder;
    }

    if (renderPlaceholder) {
      return renderPlaceholder(validationRules || []);
    }

    return generateSimpleRequiredOptionalPlaceholder(validationRules || [], t);
  }, [validationRules, propsPlaceholder, renderPlaceholder]);

  return <InputNumber {...rest} placeholder={placeholder} />;
};

export default FormInputNumber;
